(()=>{
  const $=s=>document.querySelector(s);
  const P=()=>window.NUVRA_PRODUCTS||[];
  const H=()=>window.NUVRA_HANDLES||[];
  const isMobile=()=>window.matchMedia('(max-width: 767px)').matches;
  const originalOpenIndex=window.openProductIndex;
  const originalOpenCard=window.openProduct;
  const originalClose=window.closeProduct;
  let requestToken=0;
  let verifyTimer=null;

  function handleFor(index,p){
    const h=p?.h||H()[index]||'';
    if(p&&h&&!p.h)p.h=h;
    return h;
  }
  function productUrl(index,p){
    const h=handleFor(index,p);
    return h?'/products/'+h:'';
  }
  function resetMedia(){
    const wrap=$('#productModal .product-modal-image');
    const im=$('#modalImage');
    if(verifyTimer){clearInterval(verifyTimer);verifyTimer=null}
    if(wrap)wrap.classList.remove('is-loading','is-unavailable');
    if(im){im.onload=null;im.hidden=true;im.classList.remove('is-ready');im.removeAttribute('src');im.alt=''}
  }
  function revealVerified(p,token){
    const wrap=$('#productModal .product-modal-image');
    const im=$('#modalImage');
    if(!wrap||!im)return;
    let tries=0;
    if(verifyTimer)clearInterval(verifyTimer);
    verifyTimer=setInterval(()=>{
      if(token!==requestToken){clearInterval(verifyTimer);verifyTimer=null;return}
      if(p?._live&&p.i){
        clearInterval(verifyTimer);verifyTimer=null;
        const desired=String(p.i);
        im.hidden=true;
        im.classList.remove('is-ready');
        im.onload=()=>{
          if(token!==requestToken)return;
          im.hidden=false;
          im.classList.add('is-ready');
          wrap.classList.remove('is-loading','is-unavailable');
        };
        if(im.getAttribute('src')!==desired)im.src=desired;
        if(im.complete&&im.naturalWidth)im.onload();
        return;
      }
      if(++tries>140){
        clearInterval(verifyTimer);verifyTimer=null;
        wrap.classList.remove('is-loading');
        wrap.classList.add('is-unavailable');
      }
    },50);
  }
  function openDesktop(index){
    const p=P()[index];
    if(!p)return;
    handleFor(index,p);
    const token=++requestToken;
    const wrap=$('#productModal .product-modal-image');
    const im=$('#modalImage');
    if(wrap){wrap.classList.remove('is-unavailable');wrap.classList.add('is-loading')}
    if(im){im.onload=null;im.hidden=true;im.classList.remove('is-ready');im.removeAttribute('src')}

    if(typeof originalOpenIndex==='function')originalOpenIndex(index);
    else if(typeof originalOpenCard==='function'){
      const card=document.querySelector('.product-card[data-index="'+index+'"]');
      if(card)originalOpenCard(card);
    }

    Promise.resolve().then(()=>{
      if(token!==requestToken)return;
      const img=$('#modalImage');
      if(!img)return;
      if(!p._live){img.hidden=true;img.classList.remove('is-ready');img.removeAttribute('src')}
    });
    revealVerified(p,token);
  }
  function routeIndex(index){
    index=Number(index);
    if(!Number.isFinite(index))return;
    const p=P()[index];
    if(!p)return;
    const url=productUrl(index,p);
    if(isMobile()&&url){
      requestToken++;
      resetMedia();
      window.location.assign(url);
      return;
    }
    openDesktop(index);
  }

  window.openProduct=card=>routeIndex(card?.dataset?.index);
  window.openProductIndex=routeIndex;
  window.closeProduct=function(){
    requestToken++;
    resetMedia();
    if(typeof originalClose==='function')return originalClose();
    const m=$('#productModal');
    if(m){m.classList.remove('open');m.setAttribute('aria-hidden','true')}
    document.body.style.overflow='';
  };

  document.addEventListener('click',e=>{
    if(!isMobile())return;
    const trigger=e.target.closest('#scentFinderBody [data-open]');
    if(!trigger)return;
    const index=Number(trigger.dataset.open);
    const p=P()[index];
    const url=productUrl(index,p);
    if(!url)return;
    e.preventDefault();
    e.stopImmediatePropagation();
    if(typeof window.closeFinder==='function')window.closeFinder();
    window.location.assign(url);
  },true);
})();